export default function formatDateToWeeks(data) {
  if (!data) return null;

  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  const providedKeys = Object.keys(data);
  // If less than 6 dates, pad to 6; otherwise, use the actual number.
  const targetLength = providedKeys.length < 6 ? 6 : providedKeys.length;

  const providedDa = providedKeys
    .sort((a, b) => new Date(a + 'T00:00:00Z') - new Date(b + 'T00:00:00Z'))
    .map((dateStr) => new Date(dateStr + 'T00:00:00Z'));

  const formattedDates = [];
  let currentDate = providedDa.length > 0 ? providedDa[0] : new Date();
  formattedDates.push('Today');

  for (
    let i = 1;
    i < providedDa.length && formattedDates.length < targetLength;
    i++
  ) {
    const date = providedDa[i];
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    formattedDates.push(`${daysOfWeek[date.getUTCDay()]} ${month}/${day}`);
    currentDate = date;
  }

  while (formattedDates.length < targetLength) {
    currentDate = new Date(currentDate);
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    const month = (currentDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getUTCDate().toString().padStart(2, '0');
    formattedDates.push(
      `${daysOfWeek[currentDate.getUTCDay()]} ${month}/${day}`
    );
  }

  return formattedDates;
}
